
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import imagenes from './resumen-imagenes.vue';
    import precio from './resumen-precios.vue';
    import descripcion from './resumen-descripcion.vue';
    import procesos from './resumen-menu-procesos.vue';
    import duplicar from './resumen-menu-procesos-duplicar.vue';
    import estados from './resumen-menu-estados.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            imagenes,
            precio,
            descripcion,
            procesos,
            estados,
            duplicar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Publicacion() { return this.Controlador.Publicacion; }
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onRecargarDescripcion.subscribe( x => this.Refrescar() ) );

        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
